import { bufferWhen, Observable, Subject } from 'rxjs';
import { BaseViewModel } from '../../../../../models/base/base-view-model';
import { Injectable } from '@angular/core';
import { debounceTime, filter, map } from 'rxjs/operators';
import { FileSystemService } from '../../../../../services/file-system.service';
import { ToastService } from '../../../../../modules/toasts/service/toast.service';

@Injectable()
export class SideNavHeaderViewModel extends BaseViewModel {
  constructor(
    private fileSystemService: FileSystemService,
    private toastService: ToastService
  ) {
    super();
    this.listenForAssetCacheClear();
  }

  private readonly _logoClicked = new Subject<void>();
  private readonly logoClicked$ = this._logoClicked as Observable<void>;
  logoClicked = () => this._logoClicked.next();

  private listenForAssetCacheClear() {
    this.logoClicked$
      .pipe(
        bufferWhen(() => this.logoClicked$.pipe(debounceTime(500))),
        map(clicks => clicks.length),
        filter(clickCount => clickCount >= 3)
      )
      .subscribeWhileAlive({
        owner: this,
        next: () => {
          this.fileSystemService.clearAssets();
          this.toastService.publishInfoMessage('Asset cache cleared');
        }
      });
  }
}
